/*
 * Created Date: 24-01-2024, 8:32:15 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Feb 26 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'
import { isLocalhost } from '@Core/Helpers/Url'
import { STUDIO_BE_URL } from 'env'
class Upload extends BaseService {
	uploadImage = data => {
		const endpoint = `https://studio-api-07.eduquiz.io.vn/workspace/studio/api/v1/upload?telescope=1`
		return this.request.post(endpoint, data)
	}

	uploadExamAvatar = data => {
		const endpoint = `/core/api/v1/upload`
		return this.request.post(endpoint, data)
	}
}

const uploadService = new Upload()

export default uploadService
